import React, { useEffect } from "react";
import "./index.scss";

const Modal = ({
  isOpen,
  onClose,
  title,
  entityID,
  children,
  size = "large",
  headerAction,
}) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "unset";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className={`modal-container modal-${size}`}>
        <div className="modal-header">
          <h2>
            {title}
            {entityID ? ` — ${entityID}` : ""}
          </h2>
          {headerAction ?? (
            <button className="modal-close" onClick={onClose}>
              &times;
            </button>
          )}
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
